import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import { injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import {getLocalizedMessage} from "../../../util/Localization";

const DeleteAutoLoaderConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac,intl} = props;
    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const {open, setOpen} = props;
    const [destination, setDestination] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const stateValues = {
        destination: destination,
        mac: mac
    }

    const autoLoaderConfigList = getDraftData({stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION, subKey: mac}).map(({destination}) => destination);
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")

    // Converting to set to remove non-unique destination from DDB form
    const matchedOptions = [...new Set(autoLoaderConfigList.filter(
        option => !searchQuery || searchRegExp.test(option)
    ))]

    const onClickConfirm = (stateValues) => {
        deleteData(stateValues);
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setDestination("");
    }

    const deleteData = (stateValues) => {
        deleteInstance({
            stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
            subKey: stateValues.mac,
            keyComparator: (instance) => (instance.destination === stateValues.destination)
        })
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "device.delete_config_button_modal_autoloader"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        {getLocalizedMessage({intl, stringId: "modal.destinationdelete"})}
                    </Text>
                    <Select
                        value={destination}
                        onChange={setDestination}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={getLocalizedMessage({intl, stringId: "modal.selectdestinationid"})}
                        width="100%">
                        {matchedOptions.map((destination) => (
                            <SelectOption key={destination} value={destination} label={destination}/>
                        ))}
                        {!matchedOptions.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {autoLoaderConfigList ? <Text alignment="center"> {getLocalizedMessage({ intl, stringId: "message.noMatchingDestination" })} </Text>
                                    : <Text alignment="center"> {getLocalizedMessage({ intl, stringId: "message.noDestinationAvailable" })} </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION, subKey: stateValues.mac});
                                onCloseModal();
                            }}
                        >
                            <Icon tokens={trashTokens} />
                            {getLocalizedMessage({intl, stringId: "modal.deleteAll"})}
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="small" onClick={() => onClickConfirm(stateValues)}>
                                {getLocalizedMessage({intl, stringId: "modal.confirm"})}
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAutoLoaderConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/modal/DeleteAutoLoaderConfigurationModal.js